module.exports = __webpack_public_path__ + "static/img/introduceBTypeCIcon2.2af369f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeCIcon2.png
// module id = m5D4
// module chunks = 0